<template>
  <RevCard
    class="flex flex-col gap-12 p-16 pt-12 h-320"
    data-test="finder-card"
  >
    <section class="flex flex-col">
      <header class="flex h-24 items-center gap-8 mb-12">
        <h3 class="body-1 body-1-bold grow">{{ title }}</h3>
        <RevTooltip v-if="tooltip" position="top">
          <template #trigger="{ show, hide }">
            <RevButtonBase
              :aria-label="tooltip"
              class="flex h-40 w-40 shrink-0 items-center justify-center"
              @focusin="show"
              @focusout="hide"
              @mouseleave="hide"
              @mouseover="show"
            >
              <IconQuestionMarkInCircle
                class="text-static-default-low"
                size="24"
              />
            </RevButtonBase>
          </template>
          {{ tooltip }}
        </RevTooltip>
      </header>
      <slot />
    </section>
  </RevCard>
</template>

<script lang="ts" setup>
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconQuestionMarkInCircle } from '@ds/icons/IconQuestionMarkInCircle'

defineProps<{
  title: string
  tooltip?: string
}>()
</script>
